import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthGuardService} from './services/auth/auth-guard.service';

import {AdministratorComponent} from './pages/administrator/administrator.component';
import {AudioComponent} from './pages/audio/audio.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {FaqComponent} from './pages/faq/faq.component';
import {GrupNgajiComponent} from './pages/grup-ngaji/grup-ngaji.component';
import {GuruPostinganComponent} from './pages/guru-postingan/guru-postingan.component';
import {GuruComponent} from './pages/guru/guru.component';
import {KonfigurasiComponent} from './pages/konfigurasi/konfigurasi.component';
import {LoginComponent} from './pages/login/login.component';
import {MonitoringComponent} from './pages/monitoring/monitoring.component';
import {SubscribeStoreComponent} from './pages/subscribe-store/subscribe-store.component';
import {SubscriptionPlanComponent} from './pages/subscription-plan/subscription-plan.component';
import {HafalanComponent} from './pages/hafalan/hafalan.component';
import {HafalanDetailComponent} from './pages/hafalan-detail/hafalan-detail.component';
import {MurojaahComponent} from './pages/murojaah/murojaah.component';
import {MurojaahDetailComponent} from './pages/murojaah-detail/murojaah-detail.component';
import {SahamquComponent} from './pages/sahamqu/sahamqu.component';
import {SetoranComponent} from './pages/setoran/setoran.component';
import {TilawahComponent} from './pages/tilawah/tilawah.component';
import {TilawahDetailComponent} from './pages/tilawah-detail/tilawah-detail.component';
import {UserComponent} from './pages/user/user.component';
import {VoucherBackgroudComponent} from './pages/voucher-backgroud/voucher-backgroud.component';
import {VoucherListComponent} from './pages/voucher-list/voucher-list.component';
import {SubscribeVoucherComponent} from './pages/subscribe-voucher/subscribe-voucher.component';
import {ContentFeedComponent} from './pages/content-feed/content-feed.component';
import {ContentVideoComponent} from './pages/content-video/content-video.component';
import {ComplaintComponent} from './pages/complaint/complaint.component';
import {RoleListComponent} from './pages/role-list/role-list.component';

const routes: Routes = [
  {path: 'login/:logout', component: LoginComponent, data: {title: 'Login'}},
  {path: 'login', component: LoginComponent, data: {title: 'Login'}},
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: {menu: 'dashboard', title: 'Dashboard', desc: 'Ringkasan aktivitas dan pertumbuhan aplikasi Hatam.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'audio',
    component: AudioComponent,
    data: {menu: 'audio', title: 'Audio', desc: 'Kelola file audio murottal per surat dan ayat.', canActive: []},
    canActivate: [AuthGuardService]
  },
  // old bookmarks from before the audio pages were merged
  {path: 'audio-file', redirectTo: 'audio'},
  {path: 'audio-surah', redirectTo: 'audio'},
  {
    path: 'user',
    component: UserComponent,
    data: {menu: 'user', title: 'User', desc: 'Pantau akun pengguna aplikasi, ubah status, dan reset password.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'complaint',
    component: ComplaintComponent,
    data: {menu: 'complaint', title: 'Pengaduan', desc: 'Laporan kesalahan audio dari pengguna dan status perbaikannya.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'voucher-list',
    component: VoucherListComponent,
    data: {menu: 'voucherList', title: 'List Voucher', desc: 'Buat, cetak, dan kelola kode voucher langganan.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'voucher-background',
    component: VoucherBackgroudComponent,
    data: {menu: 'voucherBackground', title: 'Background Voucher', desc: 'Desain latar untuk kartu voucher yang dicetak.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'subscribe-voucher',
    component: SubscribeVoucherComponent,
    data: {menu: 'subscribeVoucher', title: 'Berlangganan Voucher', desc: 'Langganan aktif hasil penukaran kode voucher.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'subscribe-store',
    component: SubscribeStoreComponent,
    data: {menu: 'subscribeStore', title: 'Berlangganan Store', desc: 'Langganan berbayar dari Play Store dan App Store.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'subscription-plan',
    component: SubscriptionPlanComponent,
    data: {menu: 'subscriptionPlan', title: 'Paket Langganan', desc: 'Katalog paket yang ditampilkan di halaman Berlangganan aplikasi, per platform.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'content-feed',
    component: ContentFeedComponent,
    data: {menu: 'contentFeed', title: 'Konten Feed', desc: 'Postingan foto untuk feed di aplikasi.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'content-video',
    component: ContentVideoComponent,
    data: {menu: 'contentVideo', title: 'Konten Video', desc: 'Video YouTube yang ditautkan ke aplikasi.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'hafalan',
    component: HafalanComponent,
    data: {menu: 'hafalan', title: 'Tahfidz', desc: 'Pantau hafalan pengguna (target, ayat yang dihafal, aktivitas). Hanya lihat — tidak ada aksi ubah atau hapus.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'hafalan/:id',
    component: HafalanDetailComponent,
    data: {menu: 'hafalan', title: 'Detail Tahfidz Pengguna', desc: 'Target, peta hafalan per surat, dan aktivitas menghafal satu pengguna. Hanya lihat.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'murojaah',
    component: MurojaahComponent,
    data: {menu: 'murojaah', title: "Muraja'ah", desc: "Pantau daftar muraja'ah pengguna (Juz, Surat, Halaman) dan sesi muraja'ahnya. Hanya lihat — tidak ada aksi ubah atau hapus.", canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'murojaah/:id',
    component: MurojaahDetailComponent,
    data: {menu: 'murojaah', title: "Detail Muraja'ah Pengguna", desc: "Daftar muraja'ah, peta juz, halaman lemah, dan sesi satu pengguna. Hanya lihat.", canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'setoran',
    component: SetoranComponent,
    data: {menu: 'setoran', title: 'Setoran', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'grup',
    component: GrupNgajiComponent,
    data: {menu: 'grupNgaji', title: 'Grup', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'guru',
    component: GuruComponent,
    data: {menu: 'guru', title: 'Approval Guru', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'postingan',
    component: GuruPostinganComponent,
    data: {menu: 'guruPostingan', title: 'Postingan Guru', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'monitoring',
    component: MonitoringComponent,
    data: {menu: 'monitoring', title: 'Monitoring', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'tilawah',
    component: TilawahComponent,
    data: {menu: 'tilawah', title: 'Tilawah', desc: 'Pantau grup tilawah, anggota, progres bacaan, dan aktivitasnya. Hanya lihat — tidak ada aksi ubah atau hapus.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'tilawah/:id',
    component: TilawahDetailComponent,
    data: {menu: 'tilawah', title: 'Detail Grup Tilawah', desc: 'Anggota, tugas bacaan, progres khatam, dan aktivitas satu grup. Hanya lihat.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'sahamqu',
    component: SahamquComponent,
    data: {menu: 'sahamqu', title: 'SahamQu', desc: 'Transaksi donasi SahamQu beserta status pembayarannya.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'konfigurasi',
    component: KonfigurasiComponent,
    data: {menu: 'konfigurasi', title: 'Konfigurasi', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'faq',
    component: FaqComponent,
    data: {menu: 'faq', title: 'FAQ', desc: 'Pertanyaan yang sering diajukan beserta jawabannya.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'administrator',
    component: AdministratorComponent,
    data: {menu: 'administrator', title: 'Administrator', desc: 'Kelola akun admin dashboard.', canActive: []},
    canActivate: [AuthGuardService]
  },
  {
    path: 'role',
    component: RoleListComponent,
    data: {menu: 'role', title: 'Role', desc: 'Kelola role dan akses menu untuk akun admin.', canActive: []},
    canActivate: [AuthGuardService]
  },

  {path: '', redirectTo: '/dashboard', pathMatch: 'full'},
  {
    path: '**',
    component: DashboardComponent,
    data: {menu: 'dashboard', title: 'Dashboard', desc: 'Ringkasan aktivitas dan pertumbuhan aplikasi Hatam.', canActive: []},
    canActivate: [AuthGuardService]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
